<template>
  <div>
    <GenericAutocomplete v-model="entity"
                         label="name"
                         placeholder="Buscar tercero..."
                         :search-records="findEntity"/>
  </div>
</template>

<script>
import GenericAutocomplete from "@/components/Shared/Autocomplete/GenericAutocomplete";
import entityEndpoint from "@/endpoints/core/EntityEndpoint";

export default {
  name: "EntityAutocomplete",
  components: {GenericAutocomplete},
  data() {
    return {
      entity: null
    };
  }, watch: {
    entity() {
      this.$emit('input', this.entity);
    }
  },
  methods: {
    findEntity({searchQuery, callback}) {
      entityEndpoint.findByNameOrIdentification(searchQuery)
          .then(info => callback(info));
    }
  }
}
</script>

<style scoped>

</style>